import { baseFunc, nextFetch } from "./server-base";

class API {
  url = "";
  api = baseFunc("");
  next = nextFetch("");
  constructor(url: string) {
    this.url = url;
    this.api = baseFunc(url);
    this.next = nextFetch(url);
  }
}

export const ContactUsAPI = new API("contacts.php");
export const CareersAPI = new API("careers.php");
export const UploadsAPI = new API("uploads.php");